export const common = {
  // Navigation
  nav: {
    home: 'Home',
    products: 'Products',
    repair: 'Repair Service',
    about: 'About',
    news: 'News',
    contact: 'Contact',
  },

  // Product names
  products: {
    silentUmbrella: 'Silent Umbrella',
    braidUmbrella: 'Miyabi Sakura Braided Long Umbrella',
    foldingUmbrella: 'Rain Pocket Folding Umbrella',
    parasol: 'Sun & Rain Parasol',
    koshuWeaving: 'Koshu-ori',
    others: 'Others',
  },

  // Language names
  language: {
    japanese: 'Japanese',
    english: 'English',
    chinese: 'Chinese',
  },

  // Home page sections
  home: {
    // Hero section
    hero: {
      slide1Products: {
        product1Alt: 'Silent Umbrella',
        product2Alt: 'Miyabi Sakura Braided Long Umbrella',
        product3Alt: 'Rain Pocket Folding Umbrella',
      },
      slide2: {
        title: 'Handcrafted by Japanese Artisans',
        alt: 'Main Visual 02',
      },
      slide3: {
        title: 'Inheriting Traditional Craftsmanship',
        alt: 'Main Visual 03',
      },
    },

    // About section
    about: {
      heading: 'About Maruyasu Umbrella',
      paragraph1: 'Founded in 1950, Maruyasu Umbrella Co., Ltd. has been crafting high-quality umbrellas for over 70 years. We are committed to preserving traditional Japanese umbrella-making techniques while incorporating modern innovations to create umbrellas that are both beautiful and functional.',
      paragraph2: 'Our dedication to quality and craftsmanship has made us a trusted name in the umbrella industry. From silent umbrellas to traditional braided designs, each product reflects our commitment to excellence and attention to detail.',
      button: 'Learn More',
      imageAlt: 'Maruyasu Umbrella Craftsmanship',
      stat1Value: '70+',
      stat1Label: 'Years of Experience',
      stat2Value: '100%',
      stat2Label: 'Quality Guarantee',
      stat3Value: '50+',
      stat3Label: 'Product Varieties',
    },

    // Products section
    productsSection: {
      heading: 'Products',
      subtitle: 'Our Handcrafted Collection',
      learnMore: 'Learn More',
    },

    // Silent Umbrella section
    silentUmbrella: {
      heading: 'Are you stressed by the sound of rain?',
      subheading: 'Born from the voice of visually impaired people: "We want a quiet umbrella"',
      title: 'Silent Umbrella - transforms into a quiet and comfortable sound.',
      subtitle: 'Recommended for those sensitive to sound and those involved in music and audio!',
      description: 'This umbrella has a double structure that reduces the sound of raindrops, creating a quiet rain sound that produces a calm feeling. The three-dimensional space between the mesh fabric and the umbrella fabric creates an unprecedented silhouette.',
      recommendedUsesTitle: 'Recommended Uses',
      use1: 'You can hear surrounding sounds clearly',
      use2: 'Provides coolness like being in the shade',
      use3: 'Perfect for work on rainy days',
      achievement1: 'Presented at university academic conferences.',
      achievement2: 'Patent obtained for umbrellas with rain noise reduction effect.',
      achievement3: 'Comparison experiments with regular parasols conducted using thermographic cameras.',
      imageAlt1: 'Silent Umbrella',
      imageAlt2: 'Silent Umbrella Detail',
      imageAlt3: 'Silent Umbrella Animation',
    },

    // Braid Umbrella section
    braidUmbrella: {
      heading: 'Miyabi Sakura Braided Long Umbrella',
      subheading: 'Fusion of Braided Cord and Koshu-ori',
      description1: 'A Japanese umbrella that embodies Japanese aesthetic sense!',
      description2: 'An umbrella with a Japanese atmosphere has been completed.',
      paragraph1: 'The handle is made from Nara Yoshino mountain cherry wood, carefully wrapped with braided cord. It has a pleasant feel and won\'t slip with just a light grip.',
      achievement1: 'Winner of Omotenashi Selection Award.',
      achievement2: 'Utility model patent obtained for braided cord handle.',
      imageAlt1: 'Miyabi Sakura Braided Long Umbrella',
      imageAlt2: 'Miyabi Sakura Braided Long Umbrella Detail',
    },

    // Folding Umbrella section
    foldingUmbrella: {
      heading: 'Rain Pocket Folding Umbrella',
      subheading: 'When closed, store it immediately without folding',
      description1: 'Solves the problems of folding umbrellas!',
      description2: 'When closed, store it quickly without folding.',
      description3: 'Are you having trouble storing your folding umbrella on crowded trains and buses?',
      paragraph1: 'When you have luggage on the train, wet umbrellas are easy to carry and very useful.',
      achievement1: 'Featured on TV broadcasts.',
      achievement2: 'Patent obtained.',
      imageAlt1: 'Rain Pocket Folding Umbrella',
      imageAlt2: 'Rain Pocket Folding Umbrella Detail',
    },

    // Technology section
    technology: {
      heading: 'Our Technology',
      button: 'Learn More',
      imageAlt: 'Technology',
    },

    // Applications section
    applications: {
      heading: 'Applications',
      subtitle: 'Discover the perfect umbrella for every occasion',
      dailyUse: 'Daily Use',
      dailyUseDesc: 'Perfect for everyday protection from rain and sun',
      business: 'Business',
      businessDesc: 'Professional umbrellas for business occasions',
      specialEvents: 'Special Events',
      specialEventsDesc: 'Elegant designs for ceremonies and special occasions',
      button: 'View Products',
    },

    // Repair section
    repair: {
      heading: 'SDGs',
      subheading: 'Your beloved umbrella can be used for a long time',
      paragraph1: 'Umbrellas produced domestically by our company can be repaired. Due to different fabric tensions depending on specifications, we basically only accept repairs for our domestic umbrellas.',
      paragraph2: 'We have received words of appreciation from customers regarding "repair and alteration" services.',
      button: 'Customer Testimonials & Repair History',
      beforeRepairAlt: 'Before Repair',
      afterRepairAlt: 'After Repair',
      beforeRepairLabel: 'Before Repair',
      afterRepairLabel: 'After Repair',
    },

    // News section
    news: {
      heading: 'News',
      subtitle: 'Latest Updates',
      button: 'View All News',
    },

    // Media section
    media: {
      imageAlt: 'Rain Pocket Shizuku featured on TV',
      videoTitle: 'Rain Pocket Shizuku - YouTube video player',
    },

    // Social section
    social: {
      facebookTitle: '\\Facebook - Updated Regularly/',
      facebookFeedText: 'Facebook Feed',
      facebookFollowText: 'Follow us for latest updates',
      purchaseTitle: '\\Purchase Here/',
      baseAlt: 'BASE',
      youtubeAlt: 'YOUTUBE',
      yahooShoppingAlt: 'Yahoo Shopping',
      instagramAlt: 'Instagram',
    },

    // Company section
    company: {
      heading: 'Osaka Abeno - Handcrafted by Japanese Artisans',
      subheading: 'Maruyasu Umbrella Co., Ltd.',
      description: 'Our workshop is located near JR Teradacho Station in Osaka Abeno. We handcraft umbrellas using techniques inherited from our predecessors and tools that have been used for over half a century.',
      button: 'Company Overview',
      imageAlt: 'Company Overview',
    },

    // Contact section
    contact: {
      heading: 'Contact',
      subtitle: 'Get in Touch',
      phone: '06-6713-8308',
      businessHours: 'Business Hours: 10:00-17:00 (Closed: Sat, Sun, Holidays)',
      emailButton: 'Email Inquiry',
      onlineStoreAlt: 'Visit Our Online Store',
    },
  },

  // Footer
  footer: {
    companyName: 'Maruyasu Umbrella Co., Ltd.',
    logoAlt: 'Maruyasu Umbrella Co., Ltd. | Handcrafted Japanese Umbrellas',
    address: {
      postalCode: '〒545-0001',
      line1: '2-6-15 Tennoji-cho Kita, Abeno-ku,',
      line2: 'Osaka City, Osaka',
    },
    navigation: {
      home: 'Home',
      productsHeading: 'Products',
      silentUmbrella: '- Silent Umbrella',
      braidUmbrella: '- Miyabi Sakura Braided Long Umbrella',
      foldingUmbrella: '- Rain Pocket Folding Umbrella',
      parasol: '- Sun & Rain Parasol',
      koshuOri: '- Koshu-ori',
      others: '- Others',
      aboutUs: 'About Us',
      news: 'News',
      repairService: 'Repair Service',
      contact: 'Contact',
      sitemap: 'Sitemap',
    },
    copyright: 'Copyright © Maruyasu Umbrella Co., Ltd. All rights reserved.',
    websiteBuilder: 'Website Builder',
  },

  // Common elements
  common: {
    learnMore: 'Learn More',
    viewProducts: 'View Products',
    watchVideo: 'Watch Video',
    emailInquiry: 'Email Inquiry',
    businessHours: 'Business Hours: 10:00-17:00 (Closed: Sat, Sun, Holidays)',
    phone: '06-6713-8308',
    onlineStore: 'Visit Our Online Store',
  },

  // About page
  aboutPage: {
    heroTitle: 'Company Overview',
    heroSubtitle: 'COMPANY',
    companyHeading: 'Company Overview',
    companySubtitle: 'COMPANY',
    mapHeading: 'Access Map',
    mapSubtitle: 'MAP',
    tableName: 'Company Name',
    tableNameValue: 'Maruyasu Yougasa Co., Ltd.',
    tableAddress: 'Address',
    tableAddressValue: '〒545-0001 2-6-15 Tennoji-cho Kita, Abeno-ku, Osaka City',
    tableHours: 'Business Hours',
    tableHoursValue: '10:00 - 17:00',
    tableClosed: 'Closed',
    tableClosedValue: 'Saturdays, Sundays, National Holidays, Summer holidays, Year-end and New Year holidays',
    tableTel: 'TEL',
    img1Alt: 'Maruyasu Yougasa Co., Ltd. Exterior',
    img2Alt: 'Maruyasu Yougasa Co., Ltd. Workshop',
  },

  // Contact page
  contactPage: {
    heroTitle: 'Contact Us',
    heroSubtitle: 'CONTACT',
    intro1: 'For questions, consultations, and other inquiries, please use the form below.',
    intro2: 'We also accept inquiries by phone.',
    intro3: 'After filling in each field, please click the "Send" button.',
    formName: 'Name',
    formNameSei: 'Last Name',
    formNameMei: 'First Name',
    formFurigana: 'Furigana',
    formFuriganaSei: 'Sei',
    formFuriganaMei: 'Mei',
    formEmail: 'Email Address',
    formPhone: 'Phone Number',
    formMessage: 'Inquiry Content',
    formMessagePlaceholder: 'Please limit your message to 500 characters.',
    formMessageCount: 'characters',
    formPrivacy: 'Privacy Policy',
    formPrivacyAgree: 'I agree to the Privacy Policy',
    required: 'Required',
    submit: 'Send',
    submitting: 'Sending...',
    submitSuccess: 'Thank you for your inquiry. We will contact you soon.',
    submitError: 'Failed to send your inquiry. Please try again.',
    submitErrorNetwork: 'An error occurred. Please try again.',
    infoTitle: 'Contact Information',
    infoPhone: '06-6713-8308',
    infoHours: 'Business Hours: 10:00-17:00 (Closed: Sat, Sun, Holidays)',
    infoEmail: 'Email Inquiry',
    infoEmailSub: 'Please use the form on the left',
    privacyText1: 'Maruyasu Yougasa Co., Ltd. (hereinafter referred to as "the Company") establishes the following privacy policy, builds a personal information protection system, and promotes the protection of personal information by ensuring that all employees recognize the importance of personal information protection and work on it.',
    privacyH1: '[Personal Information Management]',
    privacyP1: 'The Company keeps customers\' personal information accurate and up-to-date, and takes necessary measures such as maintaining security systems, establishing management systems, and thoroughly educating employees to prevent unauthorized access, loss, damage, falsification, and leakage of personal information, and implements safety measures to strictly manage personal information.',
    privacyH2: '[Purpose of Use of Personal Information]',
    privacyP2: 'Personal information received from customers will be used for sending emails and materials as responses to inquiries and business guidance from the Company.',
    privacyH3: '[Prohibition of Disclosure and Provision of Personal Information to Third Parties]',
    privacyP3: 'The Company appropriately manages personal information received from customers and will not disclose personal information to third parties except in the following cases:',
    privacyList1: 'When there is consent from the customer',
    privacyList2: 'When disclosing to contractors to whom the Company outsources business to provide services desired by customers',
    privacyList3: 'When disclosure is required by law',
    privacyH4: '[Security Measures for Personal Information]',
    privacyP4: 'The Company takes comprehensive security measures to ensure the accuracy and safety of personal information.',
    privacyH5: '[Inquiry by the Person]',
    privacyP5: 'When customers wish to inquire, modify, or delete their personal information, we will respond after confirming their identity.',
    privacyH6: '[Compliance with Laws and Regulations and Review]',
    privacyP6: 'The Company complies with Japanese laws and other regulations applicable to personal information held, and strives to review and improve the contents of this policy as appropriate.',
    privacyH7: '[Inquiries]',
    privacyP7: 'For inquiries regarding the Company\'s handling of personal information, please contact us below.',
    privacyCompany: 'Maruyasu Yougasa Co., Ltd.',
    privacyPostal: '〒545-0001',
    privacyAddress: '2-6-15 Tennoji-cho Kita, Abeno-ku, Osaka City',
    privacyTel: 'TEL: 06-6713-8308',
  },

  // Braid Umbrella product page
  braidPage: {
    heroTitle: 'Miyabi-Zakura Braided Long Umbrella',
    heroSubtitle: 'PRODUCT',
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Miyabi-Zakura Braided Long Umbrella',
    catchphrase: 'An umbrella that embodies Japanese aesthetic sense and can truly be called a Japanese umbrella!',
    sec1Heading: 'Traditional Japanese Craft of Braiding',
    sec1Body: 'Miyabi-Zakura was created from this concept. Using materials that evoke Japan—mountain cherry and Koshu weaving—craftsmen handcraft each umbrella one by one. Because Koshu weaving fabric is woven after dyeing the threads, the vertical and horizontal threads create an elegant, substantial texture and feel, with a unique luster.',
    sec2Heading: 'Fusion of Braiding and Umbrella',
    sec2Body: 'Inspired by kimono obi-jime (sash cords), we carefully wrap braided cord around handles carved from rare mountain cherry from Nara\'s Yoshino. The grip feel of Miyabi-Zakura is an unprecedented, comfortable touch. The handle doesn\'t slip when holding the umbrella. The unique texture of Koshu weaving and braiding creates a piece that can truly be called a Made in Japan umbrella.',
    centerText: 'Ten cords are hand-braided in a plain weave and carefully wrapped around the mountain cherry handle.',
    sec3Heading: 'Lucky Charm with Expanding Shape',
    sec3Body: 'Umbrellas have long been treated as lucky charms with an expanding shape, and have been used as betrothal gifts and wedding favors. They are also perfect as gifts for loved ones. If any problems occur, we can repair them immediately upon request, so you can use them for a long time.',
    videoHeading: 'Video Introduction',
    videoSubtitle: 'MOVIE',
    awardOmotenashi: '* Received Omotenashi Selection Award.',
    awardUtility: '* Obtained utility model for braided handle.',
    contactHeading: 'Contact Us',
    contactSubtitle: 'CONTACT',
    contactPhone: '06-6713-8308',
    contactHours: 'Business Hours: 10:00-17:00 (Closed: Sat, Sun, Holidays)',
    contactEmail: 'Email Inquiry',
    onlineStoreAlt: 'Visit our online store',
    img1Alt: 'Miyabi-Zakura Braided Long Umbrella',
    img2Alt: 'Fusion of braiding and umbrella',
    img3Alt: 'Lucky charm with expanding shape',
  },
};
